import Head from 'next/head';

//#region [Component]
export default function KommerSeo() {
	return <Head>
		<meta key="ogTitle" property="og:title" content="Kommer på kino" />

		<meta key="ogDescription" name="og:description" content="Full oversikt over alle filmer som får kinopremiere i Norge." />
		<meta key="metaDescription" name="description" content="Full oversikt over alle filmer som får kinopremiere i Norge."/>
		<meta key="metaTitle" name="title" content="Kommer på kino - Filmweb" />
		{/** TODO: image */}
		{/** TODO: +++ */}

		<title key="title">Kommer på kino - Filmweb</title>

	</Head>
}
//#endregion